<template>
	<h3 class="text-center">Informasi Kelulusan Siswa SMK PGRI 1 KEDIRI</h3>
	<el-card shadow="always">
		<template #header>
			<div class="fs-5">Tahun Ajaran {{ infoKelulusan.nama_tahun_ajaran }}</div>
		</template>
		<div>
			<span class="fs-6">Data Peserta Didik</span>
			<el-divider direction="vertical" />
			<el-tooltip content="Keluar">
				<el-button type="danger" icon="SwitchButton" size="small" plain round @click="logout" />
			</el-tooltip>
		</div>

		<el-divider class="my-3" />

		<el-descriptions :column="1" border>
			<el-descriptions-item label="Nama">{{ infoKelulusan.nama }}</el-descriptions-item>
			<el-descriptions-item label="Tempat & Tanggal Lahir">{{ infoKelulusan.ttl }}</el-descriptions-item>
			<el-descriptions-item label="Nomor Induk Siswa">{{ infoKelulusan.nis }}</el-descriptions-item>
			<el-descriptions-item label="Nomor Induk Siswa Nasional">{{ infoKelulusan.nisn }}</el-descriptions-item>
			<el-descriptions-item label="Program Keahlian">{{ infoKelulusan.nama_progli }}</el-descriptions-item>
			<el-descriptions-item label="Konsentrasi Keahlian">{{ infoKelulusan.nama_jurusan }}</el-descriptions-item>
		</el-descriptions>

		<el-divider content-position="left">Hasil Uji Kompetensi Keahlian</el-divider>
		<div class="text-center" v-loading="loadingHasilUkk">
			<div v-if="hasilUkk">
				<h5>Selamat!</h5>
				<p>Kamu dinyatakan lulus Uji Kompetensi Keahlian (UKK) dengan predikat:</p>
				<h3 class="text-primary fw-bold">{{ hasilUkk }}</h3>
			</div>
			<el-button type="primary" :loading="!isActiveUkk" @click="getHasilUkk" v-else>
				<span v-if="isActiveUkk">Lihat hasil UKK</span>
				<span v-else>{{ countdownUkk }}</span>
			</el-button>
		</div>

		<el-divider content-position="left">Status Kelulusan</el-divider>
		<div class="text-center" v-loading="loadingStatusKelulusan">
			<div v-if="statusKelulusan">
				<h5>Selamat!</h5>
				<p>Berdasarkan kriteria kelulusan SMK PGRI 1 KEDIRI Tahun Ajaran {{ infoKelulusan.nama_tahun_ajaran }}, kamu dinyatakan:</p>
				<h3 class="text-success fw-bold">{{ statusKelulusan }}</h3>
				<el-divider border-style="dashed" />

				<div v-if="infoKelulusan.file_skl">
					<div class="small mb-2">Untuk mengunduh Surat Keterangan Lulus (SKL), silakan masukkan token yang dapat diperoleh dari wali kelas.</div>
					<el-form :inline="true" :model="formSkl" :rules="ruleFormSkl" @submit.prevent="unduhSkl" ref="formSklRef" :disabled="loadingUnduhSkl">
						<el-form-item prop="token_skl">
							<el-input v-model="formSkl.token_skl" placeholder="Token unduh SKL" clearable />
						</el-form-item>
						<el-form-item>
							<el-button type="info" native-type="submit" :disabled="loadingUnduhSkl">Unduh SKL</el-button>
						</el-form-item>
					</el-form>
				</div>

				<small v-else>Silakan datang ke sekolah untuk mendapatkan berkas Surat Keterangan Lulus (SKL).</small>
			</div>
			<el-button type="success" :loading="!isActiveKelulusan" @click="getStatusKelulusan" v-else>
				<span v-if="isActiveKelulusan">Lihat status kelulusan</span>
				<span v-else>{{ countdownKelulusan }}</span>
			</el-button>
		</div>
	</el-card>
</template>

<script>
export default {
	name: "InfoKelulusan",
	data() {
		return {
			countdownUkk: "",
			countdownKelulusan: "",
			isActiveUkk: false,
			isActiveKelulusan: false,
			interval: null,
			loadingHasilUkk: false,
			loadingStatusKelulusan: false,
			hasilUkk: null,
			statusKelulusan: null,
			formSkl: {
				token_skl: "",
			},
			ruleFormSkl: {
				token_skl: [{ required: true, message: "Silakan masukkan token", trigger: "change" }],
			},
			loadingUnduhSkl: false,
		};
	},
	computed: {
		infoKelulusan() {
			return this.$store.getters.getInfoKelulusan;
		},
	},
	mounted() {
		this.updateCountdowns();

		this.interval = setInterval(this.updateCountdowns, 1000);
	},
	beforeUnmount() {
		clearInterval(this.interval);
	},
	methods: {
		calculateCountdown(targetTime) {
			const now = new Date().getTime();
			const target = new Date(targetTime).getTime();
			const diff = target - now;

			if (diff <= 0) {
				return { active: true, text: "" };
			}

			const days = Math.floor(diff / (1000 * 60 * 60 * 24));
			const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
			const minutes = Math.floor((diff / (1000 * 60)) % 60);
			const seconds = Math.floor((diff / 1000) % 60);

			const text = `${days} hari ${hours} jam ${minutes} menit ${seconds} detik`;
			return { active: false, text };
		},

		updateCountdowns() {
			const resultUkk = this.calculateCountdown(this.infoKelulusan.waktu_pengumuman_ukk);
			const resultKelulusan = this.calculateCountdown(this.infoKelulusan.waktu_pengumuman_kelulusan);

			this.isActiveUkk = resultUkk.active;
			this.countdownUkk = resultUkk.text;

			this.isActiveKelulusan = resultKelulusan.active;
			this.countdownKelulusan = resultKelulusan.text;
		},

		async getHasilUkk() {
			this.loadingHasilUkk = true;
			try {
				const { data } = await this.axios.post("/kelulusan/hasil-ukk");

				await new Promise((resolve) => setTimeout(resolve, 500));
				this.hasilUkk = data.data.hasil_ukk;
			} catch (error) {
				if (error.response) {
					if (error.response.status === 401) {
						this.$store.dispatch("logoutUser");
						return;
					}

					console.error(error.response.data.errMessage);
					this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
					return;
				}

				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				this.loadingHasilUkk = false;
			}
		},

		async getStatusKelulusan() {
			this.loadingStatusKelulusan = true;
			try {
				const { data } = await this.axios.post("/kelulusan/status-kelulusan");

				await new Promise((resolve) => setTimeout(resolve, 500));
				this.statusKelulusan = data.data.status_kelulusan;
			} catch (error) {
				if (error.response) {
					if (error.response.status === 401) {
						this.$store.dispatch("logoutUser");
						return;
					}

					console.error(error.response.data.errMessage);
					this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
					return;
				}

				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				this.loadingStatusKelulusan = false;
			}
		},

		async unduhSkl() {
			this.loadingUnduhSkl = true;
			try {
				const valid = await this.$refs.formSklRef.validate((res) => {
					return res;
				});
				if (!valid) {
					throw Error("Silakan masukkan token untuk mengunduh SKL");
				}

				const { data } = await this.axios.post(
					"/kelulusan/unduh-skl",
					{
						token_skl: this.formSkl.token_skl,
					},
					{
						responseType: "blob",
					},
				);

				await new Promise((resolve) => setTimeout(resolve, 500));
				if (data) {
					const url = window.URL.createObjectURL(new Blob([data]));

					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", this.infoKelulusan.nama + ".pdf");
					document.body.appendChild(link);
					link.click();

					link.remove();
					window.URL.revokeObjectURL(url);
				}

				this.$refs.formSklRef.resetFields();
			} catch (error) {
				if (error.response) {
					if (error.response.status === 401) {
						this.$store.dispatch("logoutUser");
						return;
					}

					const data = error.response?.data;

					if (data instanceof Blob) {
						try {
							const text = await data.text();
							const json = JSON.parse(text);
							this.$notify.error({
								title: error.response.data.error || "Gagal",
								message: json.message,
							});
						} catch {
							console.error(data.errMessage);
							this.$notify.error({
								title: data.error || "Gagal",
								message: data.message,
							});
						}
					}
					return;
				}

				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				this.loadingUnduhSkl = false;
			}
		},

		logout() {
			this.$store.dispatch("logoutUser");
		},
	},
};
</script>

<style scoped></style>
